/**
 * Filters
 */

const FILTERS = {
  TITLE: 'title',
  PLATFORM_STATUS: 'platformStatus',
  SELECT_STATUS: 'selectStatus',
  FREELANCER_ID: 'freelancerId',
  FREELANCER_NAME: 'freelancerName',
  FREELANCER_EMAIL: 'freelancerEmail',
  FREELANCER_COUNTRY: 'freelancerCountry',
  FREELANCER_LOCATION: 'freelancerLocation',
  FREELANCER_SELECT: 'freelancerIsSelect',
  LOCATION: 'location',
  SERVICES_ANY: 'servicesAny',
  SERVICES_ALL: 'servicesAll',
  VIDEO_TOPICS_ANY: 'videoTopicsAny',
  VIDEO_TOPICS_ALL: 'videoTopicsAll',
  VIDEO_CATEGORIES: 'videoCategories',
  SUBJECTS: 'subjectIds',
  MEDIUMS:  'mediumIds',
  INDUSTRIES: 'industryIds',
  FEATURED: 'is_featured',
  UNTAGGED: 'is_unclassified',
  HAS_LINK: 'hasLink',
  HOST: 'host',
  COMPANY_ID: 'companyId',
  COMPANY_NAME: 'companyName',
  COMPANY_INDUSTRY: 'companyIndustry',
  SORT: 'sort',
  ORDER: 'order',
};

const FILTERS_PROPERTY_NAMES = Object.values(FILTERS);

const FILTERS_OBJECT = FILTERS_PROPERTY_NAMES.reduce((object, filter) => {
  object[filter] = null;
  return object;
}, {});

const NULL_OPTION_LABEL = 'Any';

const NULL_OPTION = { key: NULL_OPTION_LABEL, model: null };

const ON_PLATFORM_ONLY_FILTERS = [
  FILTERS.SELECT_STATUS,
  FILTERS.LOCATION,
];

/**
 * Platform Status
 */

const PLATFORM_STATUSES = {
  OFF_PLATFORM: '0',
  ON_PLATFORM: '1',
};

const PLATFORM_STATUS_LABELS = {
  [PLATFORM_STATUSES.OFF_PLATFORM]: 'Off-platform',
  [PLATFORM_STATUSES.ON_PLATFORM]: 'On-platform',
};

const PLATFORM_STATUS_OPTIONS = [
  NULL_OPTION,
  ...Object.keys(PLATFORM_STATUSES).map((key) => ({
    key: PLATFORM_STATUS_LABELS[PLATFORM_STATUSES[key]],
    model: PLATFORM_STATUSES[key],
  })),
];

/**
 * Select Status
 */

const SELECT_STATUSES = {
  REGULAR: '0',
  SELECT: '1',
};

const SELECT_STATUS_LABELS = {
  [SELECT_STATUSES.REGULAR]: 'Regular',
  [SELECT_STATUSES.SELECT]: 'SELECT',
};

const SELECT_STATUS_OPTIONS = [
  NULL_OPTION,
  ...Object.keys(SELECT_STATUSES).map((key) => ({
    key: SELECT_STATUS_LABELS[SELECT_STATUSES[key]],
    model: SELECT_STATUSES[key],
  })),
];

/**
 * Has Link
 */

const HAS_LINK_VALUES = {
  LINK_NOT_PROVIDED: '0',
  LINK_PROVIDED: '1',
};

const HAS_LINK_LABELS = {
  [HAS_LINK_VALUES.LINK_NOT_PROVIDED]: 'No',
  [HAS_LINK_VALUES.LINK_PROVIDED]: 'Yes',
};

const HAS_LINK_OPTIONS = [
  NULL_OPTION,
  ...Object.keys(HAS_LINK_VALUES).map((key) => ({
    key: HAS_LINK_LABELS[HAS_LINK_VALUES[key]],
    model: HAS_LINK_VALUES[key],
  })),
];

/**
 * Host
 */

const HOSTS = {
  YOUTUBE: 'youtube',
  VIMEO: 'vimeo',
  FACEBOOK: 'facebook',
  OTHER: 'other',
};

const HOST_LABELS = {
  [HOSTS.YOUTUBE]: 'YouTube',
  [HOSTS.VIMEO]: 'Vimeo',
  [HOSTS.FACEBOOK]: 'Facebook',
  [HOSTS.OTHER]: 'Other',
};

const HOST_OPTIONS = [
  NULL_OPTION,
  ...Object.keys(HOSTS).map((key) => ({
    key: HOST_LABELS[HOSTS[key]],
    model: HOSTS[key],
  })),
];

/**
 * Sorting/Ordering
 */

const SORTS = {
  UPDATED_AT: 'updated_at',
  CREATED_AT: 'created_at',
};

const SORT_NAMES = {
  [SORTS.UPDATED_AT]: 'Last updated',
  [SORTS.CREATED_AT]: 'Created',
};

const ORDERS = ['desc', 'asc'];

/**
 * Project Digests
 */

const PROJECT_DIGEST_INCLUDES = [
  'application.location',
  'application.assignment',
  'brand.image',
  'classifications',
  'company',
  'oembed',
  'projectdigest-verifications:verified_or_latest',
  'review.reviewer',
  'services',
  'user.image',
  'video-category',
  'video-topics',
];

/**
 * Export
 */

export const ADMIN_CONTENT_SEARCH = {
  FILTERS,
  FILTERS_PROPERTY_NAMES,
  ON_PLATFORM_ONLY_FILTERS,
  FILTERS_OBJECT,
  NULL_OPTION_LABEL,
  NULL_OPTION,

  PLATFORM_STATUSES,
  PLATFORM_STATUS_LABELS,
  PLATFORM_STATUS_OPTIONS,

  SELECT_STATUSES,
  SELECT_STATUS_LABELS,
  SELECT_STATUS_OPTIONS,

  HAS_LINK_VALUES,
  HAS_LINK_LABELS,
  HAS_LINK_OPTIONS,

  HOSTS,
  HOST_LABELS,
  HOST_OPTIONS,

  SORTS,
  SORT_NAMES,
  ORDERS,

  PROJECT_DIGEST_INCLUDES,
};
